import { createEvent, createStore } from 'effector'

import { EtatWorkflowIncidentEnum } from '@api/enum'

export const actions = {
  setIncidentFilter: createEvent<Partial<FiltreState['incident']>>('setIncidentFilter'),
  resetIncidentFilter: createEvent('resetIncidentFilter'),
  setIncidentsFiltered: createEvent<IncidentResponse[]>('setIncidentsFiltered'),
  resetIncidentsFiltered: createEvent('resetIncidentsFiltered'),
  setUsers: createEvent<UserBasicResponse[]>('setUsersFilter'),
  resetUsers: createEvent('resetUsersFilter'),
  setMetiers: createEvent<ControleQualiteBasicMetierResponse[]>('setMetiersFilter'),
  resetMetiers: createEvent('resetMetiersFilter'),
  setManifestations: createEvent<ControleQualiteBasicManifestationResponse[]>('setManifestationsFilter'),
  resetManifestations: createEvent('resetManifestationsFilter'),
  setSocietes: createEvent<ControleQualiteBasicSocieteResponse[]>('setSocietesFilter'),
  resetSocietes: createEvent('resetSocietesFilter'),
  setSocietesIncident: createEvent<IncidentBasicSocieteResponse[]>('setSocietesIncidentFilter'),
  resetSocietesIncident: createEvent('resetSocietesIncidentFilter'),
  setOpen: createEvent<boolean>('setIncidentFilterOpen'),
  reset: createEvent('reset'),
}

export const DEFAULT_STATUSES: EtatWorkflowIncidentEnum[] = [
  EtatWorkflowIncidentEnum.DEVIS_ENVOYE,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_DEVIS,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_PRISE_EN_CHARGE,
  EtatWorkflowIncidentEnum.EN_PAUSE,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_VALIDATION,
  EtatWorkflowIncidentEnum.EN_COURS_DE_TRAITEMENT,
  EtatWorkflowIncidentEnum.REFUS_PRESTATAIRE,
]

export const emptyFilters: FiltreState['incident'] = {
  manifestation: [],
  activity: [],
  societe: [],
  status: DEFAULT_STATUSES,
  category: [],
  location: [],
  user: [],
  created: false,
  followed: false,
  isNew: false,
  isMap: false,
  search: '',
  prioritaire: false,
  from: undefined,
  to: undefined,
  mapLocationId: '',
}

export const initialState: FiltreState = {
  incident: emptyFilters,
  incidents: [],
  users: [],
  open: false,

  metiers: [],
  manifestations: [],
  societes: [],
  societesIncident: [],
}

export const store = createStore<FiltreState>(initialState, { name: 'filtre' })
  .on(actions.setIncidentFilter, (s, incident) => ({ ...s, incident: { ...s.incident, ...incident } }))
  .on(actions.resetIncidentFilter, (s) => ({ ...s, incident: emptyFilters }))
  .on(actions.setIncidentsFiltered, (s, incidents) => ({ ...s, incidents }))
  .on(actions.resetIncidentsFiltered, (s) => ({ ...s, incidents: initialState.incidents }))
  .on(actions.setUsers, (s, users) => ({ ...s, users }))
  .on(actions.resetUsers, (s) => ({ ...s, users: initialState.users }))
  .on(actions.setMetiers, (s, metiers) => ({ ...s, metiers }))
  .on(actions.resetMetiers, (s) => ({ ...s, metiers: initialState.metiers }))
  .on(actions.setManifestations, (s, manifestations) => ({ ...s, manifestations }))
  .on(actions.resetManifestations, (s) => ({ ...s, manifestations: initialState.manifestations }))
  .on(actions.setSocietes, (s, societes) => ({ ...s, societes }))
  .on(actions.resetSocietes, (s) => ({ ...s, societes: initialState.societes }))
  .on(actions.setSocietesIncident, (s, societesIncident) => ({ ...s, societesIncident }))
  .on(actions.resetSocietesIncident, (s) => ({ ...s, societesIncident: initialState.societesIncident }))
  .on(actions.setOpen, (s, open) => ({ ...s, open }))
  .reset(actions.reset)
